module.exports = __webpack_public_path__ + "img/ergoregion-3.48409ad0.png";